module.exports = __webpack_public_path__ + "img/quayThreshold.bed4481a.svg";